module.exports = __webpack_public_path__ + "media/images/responsive/logo/service/logo_kiruto-698de0c82243a309c51b197d0799f658.png";